import React from 'react';
import '../styles/components.css';
import useTranslation from '../hooks/useTranslation';
import './Loading.css';

const Loading = () => {
  const { t } = useTranslation();
  
  return (
    <div className="loading__overlay">
      <div className="spinner"></div>
      <p className="loading-text">{t('Loading')}</p>
    </div>
  );
};

export default Loading;
